import Overview from '@rebuild/materials/shared/quarterly_performance/Overview.vue';
import BaseFull from '@rebuild/materials/shared/quarterly_performance/BaseFull.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/quarterly_performance/context';

function useSelfContext() {
	provideCurrentContext();
}

export const componentMap = {
	overview: withProvider(Overview, useSelfContext),
	full: withProvider(BaseFull, useSelfContext)
};
